<script>
export default {
  name: "ButtonLink",
  props: {
    to: { type: String, required: true },
    download: { type: Boolean, required: false },
    text: { type: String, required: true },
    icon: String,
    iconPosition: { type: String, default: "right" },
    type: { type: String, default: "is-primary" },
    block: { type: Boolean, default: false },
    size: { type: String, default: "is-normal" },
  },
};
</script>

<template>
  <a :href="to" :class="['keep-button', type, block ? ' block':'', size]" :download="download">
    <span
      v-if="icon && iconPosition === 'left'"
      class="button-icon fs-keep-icon-regular left"
    >{{icon}}</span>
    <span>{{text}}</span>
    <span
      v-if="icon && iconPosition === 'right'"
      class="button-icon fs-keep-icon-regular right"
    >{{icon}}</span>
  </a>
</template>
